import {  useMemo } from 'react'
import { IAutomationObject } from '../../automationObjects';
// api
import {  useGetObjectsWithModelQuery } from '../../services/objects';
import { IDashboardCollection } from '../../features/Dashboard/types';

interface useGetDashboardsOutput {
    count: number,
    objects: IDashboardCollection[] | undefined,
    error: any,
    isLoading: boolean,
    isSuccess: boolean,
    refetch: () => void
}

const TwinModelId = 'dtmi:AutomationApps:Collections:Dashboards:DashboardCollection'

function useGetDashboards(skip = false): useGetDashboardsOutput {

    const { data, error, isLoading, isSuccess, refetch } = useGetObjectsWithModelQuery( { twinModelId: TwinModelId },{skip: skip,});

    const items = useMemo(() => {
            return data ? [...data].sort((a: IAutomationObject, b: IAutomationObject) => a.name > b.name ? 1 : -1) : [];
    }, [data]);


    return {
        count: items?.length || 0,
        objects: items,
        error: error,
        isLoading: isLoading && !items,
        isSuccess: isSuccess || (items !== undefined),
        refetch: refetch
    }
}

export default useGetDashboards